module.exports = __webpack_public_path__ + "static/img/meet_founding_team.73c96ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/meet_founding_team.png
// module id = 1762
// module chunks = 5